import apiHandler from "../core/apiHandler";

const productStockLookupApi = apiHandler("inventory/stock/lookup");

export default productStockLookupApi;
